module.exports = __webpack_public_path__ + "static/media/issue_10_cover.587f8421.png";